// @flow

import React, { type Node } from 'react';

import { InformationAccordionBody } from './information-accordion-body';

export function EbankingInformation(): Node {
  return <InformationAccordionBody label="Punto de Pago" options={OPTIONS} />;
}

const OPTIONS = {
  'BCP': [
    <p key="BCP">Ingresar a Banca por Internet: <b><a href="https://www.bcp.com.bo/" target="_blank" rel="noopener noreferrer">https://www.bcp.com.bo</a></b> y loggeate con tu usuario.</p>,
    'Verificar datos de la cuenta, continuar y seleccionar del panel derecho Pagos.',
    'Seleccionar del panel izquierdo, Pago de Servicios - PAGOSNET',
    'Seleccionar la cuenta de la que se realizará el pago.',
  ],
  'EBISA': [
    <p key="EBISA">Ingresar a Banca por Internet: <b><a href="https://ebisa.com/" target="_blank" rel="noopener noreferrer">https://ebisa.com</a></b> y loggeate con tu usuario.</p>,
    'En el panel izquierdo Operaciones de Pago, selecciona Pago de Servicios Online.',
    'Seleccionar PAGOSNET y la cuenta a debitar.',
    'Ingresar los datos a facturar NIT y NOMBRE.',
    'Seleccionar la agencia para el recojo de factura.',
  ],
  'Banco Economico': [
    <p key="Banco Economico">Ingrese a <b><a href="https://ebank.baneco.com.bo/ebank/" target="_blank" rel="noopener noreferrer">https://ebank.baneco.com.bo/ebank</a></b> e ingresa a la Opción Pagos de Servicios.</p>,
    'Seleccionar la Opción PagosNet, ingresa el código del cliente del servicio y botón consultar.',
    'Selecciona la cuenta de donde se debitará el pago y confirmar.',
  ],
  'Prodem': [
    <p key="Prodem">Ingrese a <b><a href="www.prodem.bo/" target="_blank" rel="noopener noreferrer">www.prodem.bo</a></b> y seleccione el link prodemnet.</p>,
    'Loguearse en el sitio y completar formulario.',
    'En la opción Otros, seleccione el servicio PagosNet y búsqueda por selección de CÓDIGO DE RECAUDACIÓN, ingrese su código y haga clic en continuar.',
    'Seleccionar productos a pagar, la Caja de Ahorro y registre sus datos para facturación.',
    'Verificar y confirmar datos ingresados. Solicite código SMS para confirmar.',
    'Una vez recibido el SMS, ingrese el código en el campo correspondiente.',
  ],
};
